export const getContacts = ()=>{
    const contacts = [
        {
          name : '@Abderrahmane Bouhir' , 
          compte : 'linkedin' , 
          url : 'https://www.linkedin.com/in/abderrahmane-bouhir/' ,
          color :'bg-linkedin'
        },
        {
          name : 'abouhir14@gmail.com' , 
          compte : 'email' , 
          url : 'abouhir14@gmail.com' ,
          color :'bg-email'
        } , 
        {
          name : '@Bouhir Abderrahmane' , 
          compte : 'github' , 
          url : 'https://github.com/abouhir' ,
          color :'bg-github'
        } , 
        {
          name : '@Abderrahmane Bouhir' , 
          compte : 'facebook' , 
          url : 'https://www.facebook.com/profile.php?id=100007359870372' ,
          color :'bg-facebook'
        }
        ,
        {
          name : '+212652157462' , 
          compte : 'whatsapp' , 
          url : 'https://wa.me/212652157462' ,
          color :'bg-whatsapp'
        }
    
      ];
      return contacts;
} 